"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelForm = void 0;
var tslib_1 = require("tslib");
var id_1 = require("../../id");
var form_1 = require("./form");
var DBV1Read = tslib_1.__importStar(require("./serializer/db.v1.read"));
var DBV1Write = tslib_1.__importStar(require("./serializer/db.v1.write"));
var IkeModelForm = /** @class */ (function () {
    function IkeModelForm() {
    }
    IkeModelForm.prototype.create = function () {
        var form = new form_1.FormModel();
        form.rootFormId = form.revision = id_1.IkeId.generate();
        form.createdAt = new Date();
        form.updatedAt = new Date();
        return form;
    };
    IkeModelForm.prototype.read = function (obj) {
        var createdForm = new form_1.FormModel();
        createdForm.createdAt = DBV1Read.readParseDate(obj.createdAt);
        createdForm.updatedAt = DBV1Read.readParseDate(obj.updatedAt);
        createdForm.updatedBy = obj.updatedBy;
        createdForm.name = obj.name;
        createdForm.description = obj.description;
        createdForm.displayName = obj.displayname;
        createdForm.displayVersion = obj.displayversion || 0;
        createdForm.revision = obj.version;
        createdForm.version = obj.version;
        createdForm.id = obj.objectId;
        createdForm.rootFormId = obj.uuid;
        if (obj.schema != null && Array.isArray(obj.schema.fields)) {
            DBV1Read.readSubForm(createdForm, obj.schema.fields);
        }
        DBV1Read.readMetadata(createdForm, obj.metadata);
        return createdForm;
    };
    IkeModelForm.prototype.write = function (form) {
        return {
            uuid: form.rootFormId,
            objectId: form.id,
            version: form.revision,
            revision: form.revision,
            name: form.name,
            description: form.description,
            displayname: form.displayName,
            displayversion: form.displayVersion,
            updatedBy: form.updatedBy,
            schema: DBV1Write.writeSchema(form.fields),
            metadata: DBV1Write.writeMetadata(form.metadata, form.fields),
            createdAt: form.createdAt != null ? form.createdAt.toISOString() : null,
            updatedAt: form.updatedAt != null ? form.updatedAt.toISOString() : null,
            v: 1,
            parser: 1
        };
    };
    IkeModelForm.prototype.getAttachmentIds = function (form) {
        if (form.metadata == null) {
            return [];
        }
        if (form.metadata.spidacalc != null && form.metadata.spidacalc.config != null) {
            return [form.metadata.spidacalc.config];
        }
        if (form.metadata.ocalc != null && form.metadata.ocalc.config != null) {
            return [form.metadata.ocalc.config];
        }
        if (form.metadata.poleforeman != null && form.metadata.poleforeman.config != null && !form.metadata.poleforeman.config.includes('sample')) {
            return [form.metadata.poleforeman.config];
        }
        if (form.metadata.ikePoleForeman != null && form.metadata.ikePoleForeman.config != null) {
            return [form.metadata.ikePoleForeman.config];
        }
        if (form.metadata.dds != null && form.metadata.dds.config != null) {
            return [form.metadata.dds.config];
        }
        return [];
    };
    return IkeModelForm;
}());
exports.IkeModelForm = IkeModelForm;
//# sourceMappingURL=form.model.js.map